import React from 'react';
import { OPERATIONAL_STATUS_OPTIONS } from '../../../utils/operationalListFilters';

const OperationalListFilterBar = ({
  filters,
  onChange,
  onSearch,
  onClear,
  searchLabel = 'Name / keyword',
  searchPlaceholder = 'Search',
  showStatus = true,
  showAmount = true,
}) => (
  <div className="row g-2 mb-3 align-items-end">
    <div className="col-md-2">
      <label className="form-label small mb-1">From date</label>
      <input
        type="date"
        className="form-control form-control-sm"
        name="from_date"
        value={filters.from_date || ''}
        onChange={onChange}
      />
    </div>
    <div className="col-md-2">
      <label className="form-label small mb-1">To date</label>
      <input
        type="date"
        className="form-control form-control-sm"
        name="to_date"
        min={filters.from_date || undefined}
        value={filters.to_date || ''}
        onChange={onChange}
      />
    </div>
    {showAmount && (
      <div className="col-md-2">
        <label className="form-label small mb-1">Amount</label>
        <input
          type="text"
          className="form-control form-control-sm"
          name="amount"
          placeholder="Amount"
          value={filters.amount || ''}
          onChange={onChange}
        />
      </div>
    )}
    <div className="col-md-2">
      <label className="form-label small mb-1">{searchLabel}</label>
      <input
        type="text"
        className="form-control form-control-sm"
        name="search_keyword"
        placeholder={searchPlaceholder}
        value={filters.search_keyword || ''}
        onChange={onChange}
      />
    </div>
    {showStatus && (
      <div className="col-md-2">
        <label className="form-label small mb-1">Status</label>
        <select
          className="form-control form-control-sm"
          name="status"
          value={filters.status || ''}
          onChange={onChange}
        >
          {OPERATIONAL_STATUS_OPTIONS.map((option) => (
            <option key={option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    )}
    <div className="col-md-2">
      <button type="button" className="btn btn-primary btn-sm me-2" onClick={onSearch}>
        Search
      </button>
      <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClear}>
        Clear
      </button>
    </div>
  </div>
);

export default OperationalListFilterBar;
